import { memo } from 'react'
import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material'
import { tooltipStyles as styles } from './Tooltip.style'

function Tooltip(props: TooltipProps) {
  const { slotProps } = props
  const { tooltip = {}, arrow = {} } = slotProps || {}
  return (
    <MuiTooltip
      enterTouchDelay={0}
      slotProps={{
        tooltip: { sx: styles.root, ...tooltip },
        arrow: { sx: styles.arrow, ...arrow },
      }}
      arrow
      {...props}
    />
  )
}

export default memo(Tooltip)
